import React, { useEffect, useState } from 'react';
import ColorPickerContainer from '@src/js/common/ark-extensions/dc-components/color-picker/color-picker-container';
import { ColorPickerEntry, ColorPickerType } from '@src/js/common/ark-extensions/dc-components/color-picker/type';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import styles from './index.less';
import { IEGTimeNodeChoice, IPageDataModel, ColorKey } from '@tencent/slide-sdk-model';
import PaletteIcon from '@src/framework/frame-pc/components/palette-panel/images/color-palette.svg';
import { getInitialColor } from '@src/slide/domain/ui-model/element-modeles/property/color/utils';

export interface IProps {
    onModify: Function;
    choiceList: IEGTimeNodeChoice[];
    pageDataModel?: IPageDataModel;
}

const AnimColorPicker = ({
    choiceList, pageDataModel, onModify,
}: IProps) => {
    const [color, setColor] = useState<TDColor | undefined>();
    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        const color = getInitialColor(choiceList, pageDataModel);
        setColor(color);
    }, [choiceList]);


    const handleColorChange = (color: TDColor) => {
        // 颜色变化后，设置颜色
        setColor(color);
        // 修改sdk数据中的颜色
        const { colorValue, isSchemeColor } = color;
        const colorKey = isSchemeColor ? ColorKey.schemeClr : ColorKey.srgbClr;
        // 颜色string值不带# {srgbClr: '000000'}
        onModify?.({ color: { [colorKey]: colorValue } });
    };

    const handleVisibleChange = (visible: boolean) => {
        setVisible(visible);
    };

    return <div>
        <Dropdown
            dropContent={(<ColorPickerContainer
                colorPickerType={ColorPickerType.StandardPC}
                selectedTdColor={color}
                onColorChange={handleColorChange}
                entry={ColorPickerEntry.ANIM}

            />)}
            onVisibleChange={handleVisibleChange}

        >
            <div className={styles['color-picker']}>
                <p className={styles['color-picker-left']}
                    style={{
                        backgroundColor: color?.rgba,
                    }}></p>
                <div className={styles['color-picker-right']}>
                    <img src={PaletteIcon}
                        className={`${styles['color-picker-right-icon']} ${visible ? styles['color-picker-right-icon-rotate'] : ''}`}
                    />
                </div>
            </div>
        </Dropdown>
    </div>;
};


export default AnimColorPicker;
